import { TRIGGER_TYPES } from '../../blocks/trigger';
import { HomeLoansDashboardImpressionEvent } from '../registeredEvents';
import { HomeLoansDashboardClickstreamEvent } from './HomeLoansDashboardClickstreamEvent';
import { HomeLoansDashboardBaseEventProps, getHomeLoansDashboardEvent } from './getHomeLoansDashboardEvent';
export type HomeLoansDashboardImpressionEventProps = {
    event: HomeLoansDashboardImpressionEvent;
} & HomeLoansDashboardBaseEventProps;

export const getHomeLoansDashboardImpressionEvent = ({
    event,
    lead_id,
    journey_stage_cd,
    variant_nm,
}: HomeLoansDashboardImpressionEventProps): HomeLoansDashboardClickstreamEvent =>
    getHomeLoansDashboardEvent({
        event,
        lead_id,
        journey_stage_cd,
        variant_nm,
        trigger_type_nm: TRIGGER_TYPES.IMPRESSION,
    });
